import { action, observable, runInAction } from 'mobx';

import { ErrorInterface } from 'modules/core/api/globalApi';
import { executorsController } from './executorsController';
import {
  ExecutorItem,
  ExecutorsRequest,
  AddExecutorsRequest,
} from '../../api/executorsApi';
import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';

export interface ExecutorsStore {
  executors: ExecutorItem[],
  executorsRequest: ExecutorsRequest,
  error: ErrorInterface,
}

export const executorsStore: ExecutorsStore = observable({
  executors: [],
  executorsRequest: null,
  error: null,
} as ExecutorsStore);

export const executorsActions = {

  getOrderExecutors: async (request:ExecutorsRequest): Promise<void> => {
    executorsStore.error = null;
    executorsStore.executorsRequest = request;
    const response = await executorsController.getOrderExecutors(request);
    executorsActions.handleError(response);
    if (!response.errorData) {
      runInAction(() => {
        executorsStore.executors = response?.data?.items ?? [];
        executorsStore.executors = executorsStore.executors.map((v) => {
          return {
            ...v,
            availableOrigin: v.available,
          };
        });
      });
    }
  },

  setAvailableExecutor: async (userId:string, value: boolean): Promise<void> => {
    executorsStore.executors.find((v) => v.userId === userId).available = value;
  },

  setAvailableExecutors: async (nevValues: any): Promise<void> => {
    const x = cloneDeep(executorsStore.executors);
    forEach(x, (v) => { v.available = nevValues.map((k) => k.value).includes(v.userId); });
    executorsStore.executors=x;
  },

  addOrderExecutors: async (request: AddExecutorsRequest): Promise<void> => {
    const response = await executorsController.addOrderExecutors(request);
    executorsActions.handleError(response);
  },

  deleteOrderExecutors: async (id: string): Promise<void> => {
    const response = await executorsController.deleteOrderExecutors(id);
    executorsActions.handleError(response);
  },
  
  saveExecutors: async (orderId:string): Promise<void> => {
    if (executorsStore?.executorsRequest?.orderId && orderId === executorsStore?.executorsRequest?.orderId) {
      const x = executorsStore.executors.filter((v) => v.available !== v.availableOrigin);
      if (x && x.length > 0) {
        const promises = x.map(async (item) => {
          if (item.available) {
            await executorsActions.addOrderExecutors({
              userId: item.userId,
              orderId: executorsStore.executorsRequest.orderId,
            });
          } else if (item?.id) {
            await executorsActions.deleteOrderExecutors(item?.id);
          }
        });
        await Promise.all(promises);
        executorsActions.getOrderExecutors(executorsStore.executorsRequest);
      }
    }
  },

  clearOrderExecutors: action(() => {
    executorsStore.executors = [];
    executorsStore.executorsRequest = null;
    executorsStore.error = null;
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      executorsStore.error = data;
      throw data;
    }
  }),

};
